import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "langList",
  class: "lang__list"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  ref: "langMenuList",
  class: "lang__menu"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "lang__menu-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", {
      ref: "translateTitle",
      class: "lang__title lang-header-text root-link header-link"
    }, _toDisplayString(_ctx.t("translation")), 513),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listLangs, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("p", {
            onClick: ($event: any) => (_ctx.editLang(item)),
            class: _normalizeClass(item == _ctx.activeLang ? 'lang__active' : '')
          }, _toDisplayString(item), 11, _hoisted_2)
        ]))
      }), 128))
    ], 512),
    _createElementVNode("p", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setLangs && _ctx.setLangs(...args))),
      class: "lang__title lang-menu-text root-link menu-link"
    }, _toDisplayString(_ctx.t("translation")), 1),
    (_ctx.isLang)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listLangs, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "lang__menu-list",
              key: index
            }, [
              _createElementVNode("p", {
                onClick: ($event: any) => (_ctx.editLang(item)),
                class: _normalizeClass(item == _ctx.activeLang ? 'lang__menu-item lang__active' : 'lang__menu-item')
              }, _toDisplayString(item), 11, _hoisted_4),
              (index != _ctx.listLangs.length - 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "/"))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}